import { type DriveFile } from '@/shared/DriveTypes';
import { usePopupState } from 'material-ui-popup-state/hooks';
import { AddMenuLegacy } from '~/components/AddMenuLegacy/AddMenuLegacy';
import { AddModalLegacy } from '~/components/AddMenuLegacy/AddModalLegacy';
import { AddNewButton } from '~/elements/Buttons/AddNew';
import { LEGACY } from '~/utils/constants';
import registerComponent from '~/utils/registerComponent';
import { AddMenu } from './AddMenu';

export type AddNewLegacy =
  | ((
      name: string,
      parents: DriveFile['parents'],
      type: 'document' | 'spreadsheet' | 'presentation' | 'form' | 'folder' | 'shortcut',
      targetId?: string
    ) => void)
  | undefined;

export const AddNewContainer = ({
  file,
  files,
  wiki,
  addNew,
  animation = 'right',
}: {
  file: DriveFile;
  files?: DriveFile[];
  wiki: DriveFile;
  addNew?: AddNewLegacy;
  animation?: 'left' | 'right' | 'none';
}) => {
  const popupState = usePopupState({ variant: 'popover' });
  const modalState = usePopupState({ variant: 'dialog' });

  if (LEGACY) {
    return (
      <>
        <AddNewButton file={file ?? wiki} wiki={wiki} popupState={popupState} animation={animation} />
        {popupState.isOpen && (
          <AddMenuLegacy
            file={file ?? wiki}
            wiki={wiki}
            popupState={popupState}
            addNew={addNew}
            modalState={modalState}
          />
        )}
        {modalState.isOpen && <AddModalLegacy file={file ?? wiki} modalState={modalState} addNew={addNew} />}
      </>
    );
  }

  return (
    <>
      <AddNewButton wiki={wiki} file={file} popupState={popupState} animation={animation} />
      {files && <AddMenu wiki={wiki} file={file} files={files} popupState={popupState} />}
    </>
  );
};

if (LEGACY) {
  registerComponent(AddNewContainer, 'wc-add-new', {
    file: 'json',
    wiki: 'json',
    addNew: 'function',
  });
}
